module.exports = __webpack_public_path__ + "img/BE0416144648.c44c1bd0.png";